<template>
  <div class="data-clientComp">
    <div>
      <v-row v-if="dataClient">
        <v-col cols="4" v-if="defaultValues?.['firstName'] !== ''">
          <VTextFieldWithValidation
            :rules="{ required: true, alpha_spaces: true }"
            :label="$t('directService.customerData.name')"
            type="text"
            :disabled="defaultValues?.['firstName'] !== ''"
            v-model="dataClient['firstName']"
            :class="
              defaultValues?.['firstName'] !== ''
                ? 'textField-modification'
                : ''
            "
          />
        </v-col>
        <v-col cols="4">
          <VTextFieldWithValidation
            :rules="{ required: true, alpha_spaces: true }"
            :label="$t('directService.customerData.secondName')"
            type="text"
            :disabled="defaultValues?.['lastName'] !== ''"
            v-model="dataClient['lastName']"
            :class="
              defaultValues?.['lastName'] !== '' ? 'textField-modification' : ''
            "
          />
        </v-col>
        <v-col cols="4">
          <div>
            <VTextFieldWithValidation
              :rules="{ required: false, alpha_spaces: true }"
              :label="$t('compensationSelection.clientForm.middleName')"
              type="text"
              v-model="dataClient['secondLastName']"
            />
          </div>
        </v-col>
      </v-row>
    </div>
    <div v-if="dataClient">
      <h4 class="dni-info">
        {{ $t("compensationSelection.clientForm.DNIinfo") }}
      </h4>
      <v-layout row wrap style="margin-left: 2px">
        <v-flex xs12 sm4>
          <v-select
            v-model="dataClient['documentTypes']"
            filled
            background-color="white"
            :items="documentTypes"
            :label="$t('compensation.tipoDocumento')"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm4 mt-5 mt-sm-0 class="pl-sm-2">
          <VTextFieldWithValidation
            :rules="documentNumberRules"
            :label="$t('compensation.numeroDocumento')"
            type="text"
            v-model="dataClient['documentNumber']"
          ></VTextFieldWithValidation>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import VTextFieldWithValidation from "@/components/dynamic/VTextFieldWithValidation.vue";
import { mapWritableState } from "pinia";
import { useCompensationStore } from "@/stores/compensationStore";
import { extend } from "vee-validate";

export default {
  name: "DataClientComponent",
  components: {
    VTextFieldWithValidation,
  },
  data: () => ({
    dataClient: null,
    optionSelected: null,
    defaultValues: null,
    passengerList: null,
    firstName: null,
  }),
  computed: {
    documentTypes: function () {
      return [
        {
          text: this.$i18n.t("text.passport"),
          value: "PASAPORTE",
        },
        {
          text: this.$i18n.t("text.nif"),
          value: "NIF",
        },
        {
          text: this.$i18n.t("text.dniapr"),
          value: "DNI",
        },
        {
          text: this.$i18n.t("text.nie"),
          value: "NIE",
        },
        {
          text: this.$i18n.t("compensation.others"),
          value: "SIN_DOCUMENTACION",
        },
      ];
    },
    documentNumberRules() {
      return {
        required: this.requiredRule,
        documentNumber: {
          type: this.dataClient.documentTypes,
          $t: this.$t,
        },
      };
    },
    ...mapWritableState(useCompensationStore, ["passengerData"]),
  },
  created() {
    this.loadPassengers();
    const docNumberErrorMessage = this.$t("bankDetails.docNumberError");

    extend("documentNumber", {
      validate(value, { type }) {
        if (type === "NIE") {
          const nieRegex = /^[A-Za-z]{1}[0-9]{7,8}[0-9A-Za-z]{1}$/;
          return nieRegex.test(value);
        } else if (type === "DNI") {
          const dniRegex = /^[0-9]{8}[A-Za-z]{1}$/;
          return dniRegex.test(value);
        } else if (type === "NIF") {
          const nifRegex = /^[A-Za-z]{1}[0-9]{8}$/;
          return nifRegex.test(value);
        }
        return true;
      },
      params: ["type"],
      message: docNumberErrorMessage, // Usar el mensaje ya traducido aquí
    });
  },
  methods: {
    loadPassengers() {
      this.dataClient = {
        firstName: this.passengerData.BeneficiaryFirstName || "",
        lastName: this.passengerData.BeneficiaryLastName || "",
        secondLastName: this.passengerData.BeneficarySecondLastName || "",
        documentTypes: this.passengerData.BeneficiaryDocType || "",
        documentNumber: this.passengerData.BeneficiaryDocNumber || "",
      };
      this.defaultValues = {
        ...this.dataClient,
      };
    },

    requiredRule(value) {
      return !!value || "Este campo es requerido";
    },
  },
};
</script>

<style scoped lang="scss">
.main-background {
  background-color: #fafafa;
}
.data-clientComp {
  margin: 1em 1em 2em 2em;
  @media (min-width: 960px) {
    max-width: 80%;
  }
  .passenger-info {
    font-size: 20px;
    font-family: Lato, -apple-system, blinkmacsystemfont, Segoe UI, Roboto,
      Helvetica Neue, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      Segoe UI Symbol, icomoon;
    margin-top: 16px;
    margin-bottom: 16px;
    text-decoration: none;
    color: #0f2367;
  }
  .dni-info {
    font-size: 14px;
    font-family: Lato, -apple-system, blinkmacsystemfont, Segoe UI, Roboto,
      Helvetica Neue, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      Segoe UI Symbol, icomoon;
    margin-bottom: 16px;
    text-decoration: none;
    color: #0f2367;
  }
  .btn-bank {
    color: white;
    background-color: #2d69e1;
    margin-top: 10px;
    margin-bottom: 1rem;
    margin-left: auto;
    margin-right: auto;
    height: 48px;
    border-radius: 14px;
    font-size: 16px !important;
    padding: 12px 24px;
  }
  ::v-deep .textField-modification {
    .v-input__slot {
      background-color: #f6f6f6 !important;
      border-color: #f6f6f6 !important;
      flex: none !important;

      &::before,
      &::after {
        border: none !important;
      }
    }

    .v-text-field .v-label {
      color: #616161 !important;
      font-size: 16px !important;
      font-family: Roboto, sans-serif !important;
    }

    .theme--light.v-input--is-disabled input {
      color: rgba(0, 0, 0, 0.87) !important;
    }
  }
}
</style>
